var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "grid grid--dashboard" },
    [_c("Version"), _c("Fleet")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }